// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import fetch from './utils/fetch'
import VueQuillEditor from 'vue-quill-editor'
import proportion from 'vue-proportion-directive'


// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor, /* { default global options } */ )
Vue.use(proportion)


Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$fetch = fetch

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})
var instance = axios.create({
    baseURL: '',
    timeout: 5000,
    headers: { 'Content-Type': 'multipart/form-data' }
})

Vue.prototype.axios = axios
Vue.prototype.instance = instance


// WEBPACK FOOTER //
// ./src/main.js